<template>
  <v-container class="white" style="border-radius: 0.8em">
    <span class="font-weight-medium mb-2 h3">Alerts notifications</span>

    <!-- Add radio buttons for selection -->
    <v-radio-group
      v-if="!emptyNotifications"
      v-model="selectedGrouping"
      class="mb-3"
      row
    >
      <v-radio label="Group by Vessel" value="vessel"></v-radio>
      <v-radio label="Group by Rule" value="rule"></v-radio>
    </v-radio-group>

    <v-container
      :style="{
        overflowY: 'auto',
        maxHeight: notificationsContainerHeight,
        padding: '0px',
      }"
    >
      <GroupByRule v-if="selectedGrouping == 'rule'" />
      <GroupByVessel v-if="selectedGrouping == 'vessel'" />
      <v-alert v-if="emptyNotifications" type="info" text>
        No notifications available
      </v-alert>
    </v-container>

    <div style="height: 2em"></div>

    <div
      class="d-flex flex-column align-center"
      style="width: min-content; justify-self: center"
    >
      <v-btn
        color="primary"
        @click="onIgnoreSelected"
        :loading="updateLoadingState"
        :disabled="ignoreSelectedDisabled"
        min-width="0"
        class="px-4"
      >
        Ignore Selected
      </v-btn>
      <div style="height: 0.5em"></div>
      <v-btn
        color="primary"
        min-width="0"
        class="px-4"
        text
        @click="onCancelPressed"
      >
        Cancel
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import GroupByRule from "./components/GroupByRule.vue";
import GroupByVessel from "./components/GroupByVessel.vue";
export default {
  name: "NotificationDialog",
  components: {
    GroupByRule,
    GroupByVessel,
  },
  props: {
    onCancelPressed: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      selectedGrouping: "vessel", // New data property for grouping selection
    };
  },
  computed: {
    ...mapState("notifications", ["updateLoadingState"]),
    ...mapGetters("notifications", [
      "noNotificationsSelected",
      "emptyNotifications",
    ]),
    notificationsContainerHeight() {
      return this.$vuetify.breakpoint.xlAndUp ? "500px" : "400px";
    },
    ignoreSelectedDisabled() {
      return this.noNotificationsSelected || this.emptyNotifications;
    },
  },
  methods: {
    async onIgnoreSelected() {
      await this.$store.dispatch("notifications/updateNotifications");
    },
  },
  mounted() {
  this.$store.dispatch("notifications/fetchNotifications");
}

};
</script>

<style scoped>
.v-list-item {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}
</style>
